// extracted by mini-css-extract-plugin
module.exports = {"newHeader":"header-module--newHeader--3WmrV","header":"header-module--header--2Q3RK","headerNav":"header-module--headerNav--2ALTk","branding":"header-module--branding--3jgsl"};